"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const event_fragment_1 = __importDefault(require("../fragments/event.fragment"));
const query = (0, client_1.gql) `
  query eventsAdmin(
    $query: EventQueryInput
    $pagination: PaginationInput
    $orgId: String
  ) {
    eventsAdmin(query: $query, pagination: $pagination, orgId: $orgId) {
      _id
      orgId
      type
      name
      seasonId
      subtitle
      description
      userAgreement
      processAs
      posterImageUrl {
        original
        medium
        small
      }
      venueId
      createdAt
      publishable
      published
      seatingChartKey
      age
      isMultipleDays
      totalDays
      cancel
      sendQRCode
      hasOrders
      taxDeduction
      stub
      venue {
        _id
        name
        tax
        address {
          state
          city
          timezone
        }
        imageUrls
      }
      ...EventSchedule
      ...TicketTypes
      ...Performances
      ...Analytics
    }
  }
  ${event_fragment_1.default.fragments.schedule}
  ${event_fragment_1.default.fragments.ticketTypes}
  ${event_fragment_1.default.fragments.performances}
  ${event_fragment_1.default.fragments.analytics}
  
`;
exports.default = query;
//# sourceMappingURL=eventsAdminCalender.query.js.map